import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import DashboardContainer from "../../../Dashboard_en/DashboardContainer";
import DashboardContainerHeader from "../../../Dashboard_en/Components/DashboardContainerHeader/DashboardContainerHeader";
import { toast } from "react-toastify";
import TextInput from "../../../Dashboard_en/Components/Inputs/TextInput/TextInput";
import TextAreaInput from "../../../Dashboard_en/Components/Inputs/TextAreaInput/TextAreaInput";
import ApiName from "../../../ApiName";
import axios from "axios";

const createEducation = async (aboutLoad) => {
  let input = document.getElementById("newEducation");
  let value = input.value;
  if (!value || !input) {
    toast.warning("fill the input first!");
    return;
  }
  try {
    await axios.post(`${ApiName}/About/education?education=${value}`, null, {
      headers: {
        Authorization: localStorage.authToken,
        "Content-Type": "application/json",
      }
    });
    toast.success("education added successfully!");
    input.value = "";
    aboutLoad();
  } catch (error) {
    toast.error("Error creating education");
  }
};

const createExhibition = async (aboutLoad) => {
  let input = document.getElementById("newExhibition");
  let value = input.value;
  if (!value || !input) {
    toast.warning("fill the input first!");
    return;
  }
  try {
    await axios.post(`${ApiName}/About/exhibition?exhibition=${value}`, null, {
      headers: {
        Authorization: localStorage.authToken,
        "Content-Type": "application/json",
      }
    });
    toast.success("exhibition added successfully!");
    input.value = "";
    aboutLoad();
  } catch (error) {
    toast.error("Error creating exhibition");
  }
};

const removeEducation = async (educationId, aboutLoad) => {
  try {
    await axios.delete(`${ApiName}/About/education/${educationId}`, {
      headers: { Authorization: localStorage.authToken },
    });
    toast.success("item removed Successfully!");
    aboutLoad();
  } catch (error) {
    toast.error("Error removing education");
  }
};

const removeExhibition = async (exhibitionId, aboutLoad) => {
  try {
    await axios.delete(`${ApiName}/About/exhibition/${exhibitionId}`, {
      headers: { Authorization: localStorage.authToken },
    });
    toast.success("item removed Successfully!");
    aboutLoad();
  } catch (error) {
    toast.error("Error removing exhibition");
  }
};

const SimpleTable = ({ data, columns }) => (
  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 rounded-lg">
    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <thead className="bg-gray-50 dark:bg-gray-800">
        <tr>
          {columns.map((col, idx) => (
            <th key={idx} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              {col.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
        {data.length === 0 ? (
          <tr>
            <td colSpan={columns.length} className="px-6 py-4 text-center text-gray-500">
              No data available
            </td>
          </tr>
        ) : (
          data.map((row, i) => (
            <tr key={i}>
              {columns.map((col, idx) => (
                <td key={idx} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                  {col.render ? col.render(row) : row[col.field]}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

const AdminAbout = () => {
  const fileInputRef = useRef();
  
  const loadAbout = async () => {
    try {
      const response = await axios.get(`${ApiName}/About`);
      setAboutData(response.data);
      setEducations(response.data.aboutEducations || []);
      setExhibitions(response.data.aboutExhibitions || []);
    } catch (error) {
      toast.error("There was problem getting The details!");
    }
  };

  const handleVideoLinkChange = async () => {
    let doc = document.getElementById("aboutVideo");
    if (!doc || !doc.value) return;
    if (doc.value !== aboutData.aboutVideo) {
      try {
        await axios.patch(`${ApiName}/About/video?link=${doc.value}`, null, {
          headers: { Authorization: localStorage.authToken }
        });
        loadAbout();
        toast.success("video link changed successfully");
      } catch (e) {
        toast.error("Error changing video link");
      }
    }
  };

  const handleVideoDescChange = async () => {
    let doc = document.getElementById("aboutVideoDesc");
    if (!doc || !doc.value) return;
    if (doc.value !== aboutData.aboutVideoDesc) {
      try {
        await axios.patch(`${ApiName}/About/videoDescribtion?desc=${doc.value}`, null, {
          headers: { Authorization: localStorage.authToken }
        });
        loadAbout();
        toast.success("video description changed successfully");
      } catch (e) {
        toast.error("Error changing video description");
      }
    }
  };

  const handleDescChange = async () => {
    let doc = document.getElementById("aboutDesc");
    if (!doc || !doc.value) return;
    if (doc.value !== aboutData.aboutDesc) {
      try {
        await axios.patch(`${ApiName}/About/Describtion?desc=${doc.value}`, null, {
          headers: { Authorization: localStorage.authToken }
        });
        loadAbout();
        toast.success("Description changed successfully");
      } catch (e) {
        toast.error("Error changing description");
      }
    }
  };

  const uploadHandler = async (event) => {
    if (!event.target.files || event.target.files.length === 0) return;
    const file = event.target.files[0];
    if (file.size > 4194304) {
      toast.error("File exceeds the 4 MB limit.");
      return;
    }

    setUploadDisabled(true);
    var form = new FormData();
    form.append("image", file);

    try {
      await axios.patch(`${ApiName}/About/aboutImage`, form, {
        headers: {
          Authorization: localStorage.authToken
        }
      });
      loadAbout();
      toast.success("you uploaded the Image successfully!");
    } catch (error) {
      toast.error("Failed to upload image");
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setUploadDisabled(false);
    }
  };

  const [educations, setEducations] = useState([]);
  const [exhibitions, setExhibitions] = useState([]);
  const [aboutData, setAboutData] = useState({
    socialMedia: [],
    aboutImage: null,
    aboutVideo: null,
    aboutVideoDesc: null,
    aboutDesc: null,
    aboutExhibitions: [],
    aboutEducations: [],
  });
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const timeoutIdRef = useRef(null);

  useEffect(() => {
    loadAbout();
    
    const videoInput = document.getElementById("aboutVideo");
    const videoDescInput = document.getElementById("aboutVideoDesc");
    const descInput = document.getElementById("aboutDesc");

    const onVideoInput = () => {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        handleVideoLinkChange();
      }, 3000);
    };

    const onVideoDescInput = () => {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        handleVideoDescChange();
      }, 3000);
    };

    const onDescInput = () => {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(() => {
        handleDescChange();
      }, 3000);
    };

    videoInput?.addEventListener("input", onVideoInput);
    videoDescInput?.addEventListener("input", onVideoDescInput);
    descInput?.addEventListener("input", onDescInput);

    return () => {
      videoInput?.removeEventListener("input", onVideoInput);
      videoDescInput?.removeEventListener("input", onVideoDescInput);
      descInput?.removeEventListener("input", onDescInput);
      clearTimeout(timeoutIdRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, transition: { duration: 0.1 } }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.1 } }}
      className="grid grid-cols-1 gap-3 px-5 "
    >
      <DashboardContainer classNames={"text-zinc-900"} text="Image List">
        <DashboardContainerHeader
          classNames={"text-zinc-900"}
          text="About Image"
        />
        <div>
          <p className="pt-5 pl-5 text-xl sans-regular text-gray-900 dark:text-white">Current About Image</p>
          {aboutData.aboutImage != null ? (
            <img
              src={`${ApiName}/${aboutData.aboutImage}`}
              className="h-full p-5 w-96 object-cover"
              alt="About"
            />
          ) : null}
        </div>
        <div className="flex">
          <div className="mx-auto my-10 flex flex-col items-center">
            <p className="mb-3 text-xs text-center text-gray-500 dark:text-gray-400">
              📎 Max <strong>4 MB</strong> — auto-converted to <strong>WebP</strong>
            </p>
            <label className="cursor-pointer bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg font-medium transition-colors">
              Select a file
              <input 
                type="file" 
                className="hidden" 
                accept="image/*" 
                onChange={uploadHandler} 
                disabled={uploadDisabled}
                ref={fileInputRef}
              />
            </label>
          </div>
        </div>
      </DashboardContainer>

      <DashboardContainer classNames={"text-zinc-900"} text="About Settings">
        <DashboardContainerHeader
          classNames={"text-zinc-900"}
          text="About Settings"
        />
        <div className="m-5 mb-10 space-y-4">
          <TextInput
            value={aboutData.aboutVideo || ""}
            label="Video Link"
            id="aboutVideo"
          />
          <TextInput
            value={aboutData.aboutVideoDesc || ""}
            label="Video Description"
            id="aboutVideoDesc"
          />
          <TextAreaInput
            value={aboutData.aboutDesc || ""}
            label="About Description"
            id="aboutDesc"
          />
        </div>
      </DashboardContainer>

      <DashboardContainer classNames={"text-zinc-900"} text="Education Settings">
        <DashboardContainerHeader
          classNames={"text-zinc-900"}
          text="Education Settings"
        />
        <div className="flex flex-col sm:flex-row w-full p-5 gap-4 items-end">
          <div className="flex-1 w-full">
            <TextInput
              value=""
              label="New Education"
              id="newEducation"
            />
          </div>
          <button 
            onClick={() => createEducation(loadAbout)} 
            className="px-6 py-2 h-[42px] mb-1 text-white bg-zinc-900 rounded-lg hover:bg-zinc-700 font-medium transition-colors"
          >
            Create
          </button>
        </div>
        <div className="p-5">
          <SimpleTable 
            data={educations} 
            columns={[
              { header: "Education", field: "name" },
              { 
                header: "Action", 
                render: (row) => (
                  <button
                    className="px-3 py-1.5 text-sm text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                    onClick={() => removeEducation(row.id, loadAbout)}
                  >
                    Delete
                  </button>
                )
              }
            ]} 
          />
        </div>
      </DashboardContainer>

      <DashboardContainer classNames={"text-zinc-900"} text="Exhibitions Settings">
        <DashboardContainerHeader
          classNames={"text-zinc-900"}
          text="Exhibitions Settings"
        />
        <div className="flex flex-col sm:flex-row w-full p-5 gap-4 items-end">
          <div className="flex-1 w-full">
            <TextInput
              value=""
              label="New Exhibition"
              id="newExhibition"
            />
          </div>
          <button 
            onClick={() => createExhibition(loadAbout)} 
            className="px-6 py-2 h-[42px] mb-1 text-white bg-zinc-900 rounded-lg hover:bg-zinc-700 font-medium transition-colors"
          >
            Create
          </button>
        </div>
        <div className="p-5">
          <SimpleTable 
            data={exhibitions} 
            columns={[
              { header: "Exhibition", field: "name" },
              { 
                header: "Action", 
                render: (row) => (
                  <button
                    className="px-3 py-1.5 text-sm text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
                    onClick={() => removeExhibition(row.id, loadAbout)}
                  >
                    Delete
                  </button>
                )
              }
            ]} 
          />
        </div>
      </DashboardContainer>
    </motion.div>
  );
};

export default AdminAbout;
